
import { BasicController, BasicCustomCursor } from "@goodgamestudios/core";
import { TextFieldHelper } from "@goodgamestudios/core";
import { Poker2RankingDataEvent } from "../../../event/Poker2RankingDataEvent";
import { AvatarCardVO } from "../../../gamevo/AvatarCardVO";
import { Poker2Model } from "../../../model/Poker2Model";
import { PokerTextHelper } from "../../helper/PokerTextHelper";

import { NumberStringHelper } from "../../../helper/NumberStringHelper";

import MovieClip = createjs.MovieClip;
import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;
import Rectangle = createjs.Rectangle;

export class Poker2RankingTopPlayer {
    private disp: MovieClip;	//	rankingDialog.mc_topplayer

    /**
     * @param disp
     */
    constructor(disp: MovieClip) {
        this.disp = disp;
    }

    public applyProperties(): void {
        this.disp.mouseEnabled = true;
        this.disp.mouseChildren = true;
    }
    public show(): void {
        this.controller.addEventListener("changeRankingTopAvatarData", this.bindFunction(this.onChangeTopAvatarData));
        this.disp.addEventListener(MouseEvent.CLICK, this.bindFunction(this.onClick));
        let cards = [1, 2, 3];
        cards.forEach(i => {
            let mc = this.disp["mc_card" + i];
            mc.mouseChildren = false;
            mc.addEventListener(MouseEvent.ROLL_OVER, this.bindFunction(this.onMouseIn));
            mc.addEventListener(MouseEvent.ROLL_OUT, this.bindFunction(this.onMouseOut));
        });
    }
    public hide(): void {
        this.controller.removeEventListener("changeRankingTopAvatarData", this.bindFunction(this.onChangeTopAvatarData));
        this.disp.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.onClick));
        let cards = [1, 2, 3];
        cards.forEach(i => {
            let mc = this.disp["mc_card" + i];
            mc.removeEventListener(MouseEvent.ROLL_OVER, this.bindFunction(this.onMouseIn));
            mc.removeEventListener(MouseEvent.ROLL_OUT, this.bindFunction(this.onMouseOut));
        });
    }
    private onChangeTopAvatarData(event: Poker2RankingDataEvent): void {
        this.fillTopAvatarRanking(Poker2Model.rankingData.rankingTopAvatar);
    }

    public onClick(event: MouseEvent): void {
        let card = event.target;
        switch (card) {
            case this.disp.mc_card1:
            case this.disp.mc_card2:
            case this.disp.mc_card3:
                Poker2RankingDialog.getAvatarCard(card.properties);
                break;
        }
    }

    private onMouseIn(event: MouseEvent) {
        Poker2LayoutManager.getInstance().customCursor.setCursorType(BasicCustomCursor.CURSOR_CLICK);
    }

    private onMouseOut(event: MouseEvent) {
        Poker2LayoutManager.getInstance().customCursor.setCursorType(BasicCustomCursor.CURSOR_ARROW);
    }

    private fillTopAvatarRanking(rankingTopAvatar: AvatarCardVO[]): void {
        var element: AvatarCardVO;
        var i: number = 0;

        this.hideAllCards();
        if (rankingTopAvatar.length > 0) {
            for (i = 0; i < rankingTopAvatar.length; i++) {
                element = rankingTopAvatar[i] as AvatarCardVO;
                this.updateTopRankingCards(element, i + 1);
            }
        }
    }

    private updateTopRankingCards(rankingAvatarVO: AvatarCardVO, rank: number): void {
        var playerCard: Library.PokerInterface.RankingPlayerCard;
        var mcAvatar: Container;
        var bounds: Rectangle;
        var scaleFactor: number = NaN;

        playerCard = this.disp["mc_card" + rank] as Library.PokerInterface.RankingPlayerCard;
        playerCard.bg.doCache(0, Poker2LayoutManager.GAME_SCALE_FACTOR);
        playerCard.visible = true;
        playerCard.mc_avatar_bg.gotoAndStop(rank);
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, playerCard.txt_name, rankingAvatarVO.name);
        Poker2TextFieldHelper.changeTextFromatSizeByMaxHeight(9, playerCard.txt_level, String(rankingAvatarVO.level));
        playerCard.txt_xp.text = PokerTextHelper.getShortGroupNumberString(rankingAvatarVO.xp);
        playerCard.txt_chips.text = PokerTextHelper.getShortGroupNumberString(rankingAvatarVO.chips);
        playerCard.properties = rankingAvatarVO.id;
        playerCard.mc_avatar.mouseEnabled = false;
        playerCard.mc_avatar_bg.mouseEnabled = false;

        while (playerCard.mc_avatar.numChildren > 0)
            playerCard.mc_avatar.removeChildAt(0);

        mcAvatar = AvatarHelper.drawAvatarByItemArray(Poker2Model.avatarData.getAvatarClothesArray(rankingAvatarVO.avatar));
        /// mcAvatar = new AvatarHolder( rankingAvatarVO.avatar ) as Sprite;
        bounds = mcAvatar.getBounds(null);
        scaleFactor = (150 / bounds.width);
        if ((bounds.height * scaleFactor) > 120)
            scaleFactor = (120 / bounds.height);
        mcAvatar.scaleX = mcAvatar.scaleY = scaleFactor;
        mcAvatar.x = - ((bounds.width * scaleFactor) / 2 + (bounds.left * scaleFactor));
        mcAvatar.y = - ((bounds.height * scaleFactor) / 1.8 + (bounds.top * scaleFactor));
        mcAvatar.mouseEnabled = true;
        playerCard.mc_avatar.addChild(mcAvatar);
        playerCard.mc_avatar.doCache(0, 2);
    }

    private hideAllCards(): void {
        this.disp.mc_card1.visible = false;
        this.disp.mc_card2.visible = false;
        this.disp.mc_card3.visible = false;
    }

    //
    // getter & setter
    //

    protected get controller(): BasicController {
        return BasicController.getInstance();
    }

    //
    // end
    //
}
import { Poker2RankingDialog } from "../../dialogs/ranking/Poker2RankingDialog";
import { AvatarHelper } from "../../helper/AvatarHelper";
import { Poker2LayoutManager } from "../../Poker2LayoutManager";
import {Poker2TextFieldHelper} from "../../helper/Poker2TextFieldHelper";
